export default class CabecalhoElemento {
    constructor(elemento, id){
        this.elemento = elemento;
        this.id = id;
    }

    asc(){
        this.elemento.classList.add('desc');
        this.elemento.classList.remove('asc');
    }

    desc(){
        this.elemento.classList.add('asc');
        this.elemento.classList.remove('desc');
    }

    reset(){
        this.elemento.classList.remove('asc');
        this.elemento.classList.remove('desc');
    }
}